import {
	REFRESH_CATEGORY_FILTER,
	SET_CATEGORY_FILTER,
} from './types'

const initialState = {
	options: [],
	refresh: false,
	initialize: true
};

const reducer = (state = initialState, {type, payload}) => {

	switch (type) {

		case REFRESH_CATEGORY_FILTER:
			return {
				...state,
				refresh: true,
				initialize: true,
				options: [],
			}
		
		case SET_CATEGORY_FILTER:
			return {
				...state,
				refresh: false,
				initialize: false,
				options: payload
			}

		default:
			return state;

	}

}

export default reducer